import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconChevronBottom: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"chevron-bottom"} maskId="square-filled-radius-0-stroke-1-IconChevronBottom"><path fillRule="evenodd" clipRule="evenodd" d="M11.9999 17.707L3.29282 8.99993L3.99992 8.29282L11.9999 16.2928L19.9999 8.29282L20.707 8.99992L11.9999 17.707Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconChevronBottom;
